import { createFeatureSelector, createSelector } from '@ngrx/store';
import { extensionGroupRegisterFeatureKey, ExtensionGroupRegisterState } from './extension-group-register.reducer';

const extensionGroupRegisterSelector = createFeatureSelector<ExtensionGroupRegisterState>(
   extensionGroupRegisterFeatureKey
);

export const selectFilters = createSelector(extensionGroupRegisterSelector, (state) => {
   return state.filters;
});
